export const RoleMenu = [
    {
        "eventKey": "dashboard",
        "label": "Dashboard",
        "path": "/:lng/dashboard",
        "crud": false,
        "read": false,
        "write": false,
        "subeventKey": [
            {
                "eventKey": "financial_insights",
                "label": "Financial Insights",
                "crud": false,
                "read": false,
                "write": false
            },
            {
                "eventKey": "frontdesk",
                "label": "Front Desk",
                "crud": false,
                "read": false,
                "write": false
            },
            {
                "eventKey": "housekeeping",
                "label": "Housekeeping",
                "crud": false,
                "read": false,
                "write": false
            },
            {
                "eventKey": "occupancycalendar",
                "label": "Inventory Overview",
                "crud": false,
                "read": false,
                "write": false
            },
            {
                "eventKey": "room_occupancy_distribution",
                "label": "Room Occupancy Distribution",
                "crud": false,
                "read": false,
                "write": false
            },
            {
                "eventKey": "booking_volume_trend",
                "label": "Booking Volume Trend",
                "crud": false,
                "read": false,
                "write": false
            },
            {
                "eventKey": "average_order_value",
                "label": "Average Order Value",
                "crud": false,
                "read": false,
                "write": false
            },
            {
                "eventKey": "tax_collection_trend",
                "label": "Tax Collection Trend",
                "crud": false,
                "read": false,
                "write": false
            },
            {
                "eventKey": "room_availability_timeline",
                "label": "Room Availability Timeline",
                "crud": false,
                "read": false,
                "write": false
            },
            {
                "eventKey": "booking_activity_status",
                "label": "Booking Activity Status",
                "crud": false,
                "read": false,
                "write": false
            },
            {
                "eventKey": "daily_visitor_analytics",
                "label": "Daily Visitor Analytics",
                "crud": false,
                "read": false,
                "write": false
            },
            {
                "eventKey": "recent_visitor_details",
                "label": "Recent Visitor Details",
                "crud": false,
                "read": false,
                "write": false
            },
        ]
    },
    {

        "eventKey": "user",
        "label": "User Profile",
        "path": "/:lng/home/user",
        "crud": false,
        "read": false,
        "write": false,
        "subeventKey": [
            {
                "eventKey": "personal",
                "label": "Personal",
                "crud": false,
                "read": false,
                "write": false
            },
            {
                "eventKey": "professional",
                "label": "Professional",
                "crud": false,
                "read": false,
                "write": false
            }
        ]
    },
    {
        "eventKey": "branch",
        "label": "Branches",
        "path": "/:lng/home/branch",
        "crud": false,
        "read": false,
        "write": false
    },
    {
        "eventKey": "room_type",
        "label": "Room Types",
        "path": "/:lng/home/room_type",
        "crud": false,
        "read": false,
        "write": false
    },
    {
        "eventKey": "room_features",
        "label": "Room Features",
        "path": "/:lng/home/room_features",
        "crud": false,
        "read": false,
        "write": false
    },
    {
        "eventKey": "package_tour",
        "label": "Tour",
        "path": "/:lng/home/package_tour",
        "crud": false,
        "read": false,
        "write": false
    },
    {
        "eventKey": "variants",
        "label": "Variants",
        "path": "/:lng/home/variants",
        "crud": false,
        "read": false,
        "write": false
    },

    {
        "eventKey": "inventory",
        "label": "Inventory",
        "path": "/:lng/home/inventory",
        "crud": false,
        "read": false,
        "write": false,
        "subeventKey": [
            {
                "eventKey": "category",
                "label": "Category",
                "path": "/:lng/home/inventory/category",
                "crud": false,
                "read": false,
                "write": false
            },
            {
                "eventKey": "item_master",
                "label": "Item Master",
                "path": "/:lng/home/inventory/item_master",
                "crud": false,
                "read": false,
                "write": false
            },
            {
                "eventKey": "purchase_order",
                "label": "Purchase Order",
                "path": "/:lng/home/inventory/purchase_order",
                "crud": false,
                "read": false,
                "write": false
            },
            {
                "eventKey": "room_item_inventory",
                "label": "Room Item Inventory",
                "path": "/:lng/home/inventory/room_item_inventory",
                "crud": false,
                "read": false,
                "write": false
            },
            {
                "eventKey": "item_consumption_log",
                "label": "Item Consumption Log",
                "path": "/:lng/home/inventory/item_consumption_log",
                "crud": false,
                "read": false,
                "write": false
            },
            {
                "eventKey": "item_damage_log",
                "label": "Item Damage Log",
                "path": "/:lng/home/inventory/item_damage_log",
                "crud": false,
                "read": false,
                "write": false
            }
        ]
    },
    {
        "eventKey": "room_price_override",
        "label": "Room Variant Price Override",
        "path": "/:lng/home/room_price_override",
        "crud": false,
        "read": false,
        "write": false
    },
    {
        "eventKey": "block_room",
        "label": "Block Room",
        "path": "/:lng/home/block_room",
        "crud": false,
        "read": false,
        "write": false
    },
    {
        "eventKey": "booking_room",
        "label": "Bookings",
        "path": "/:lng/home/booking_room",
        "crud": false,
        "read": false,
        "write": false
    },
    {
        "eventKey": "room_facility",
        "label": "Room Facilities",
        "path": "/:lng/home/room_facility",
        "crud": false,
        "read": false,
        "write": false
    },
    {
        "eventKey": "amenities",
        "label": "Hotel Amenities",
        "path": "/:lng/home/amenities",
        "crud": false,
        "read": false,
        "write": false
    },
    {
        "eventKey": "booking_rules",
        "label": "Booking Rules",
        "path": "/:lng/settings/booking_rules",
        "crud": false,
        "read": false,
        "write": false
    },
    {
        "eventKey": "cancellation_rules",
        "label": "Cancellation Rules",
        "path": "/:lng/settings/cancellation_rules",
        "crud": false,
        "read": false,
        "write": false
    },
    {
        "eventKey": "tax",
        "label": "Tax Rules",
        "path": "/:lng/settings/tax",
        "crud": false,
        "read": false,
        "write": false
    },
    {
        "eventKey": "role",
        "label": "Roles",
        "path": "/:lng/settings/role",
        "crud": false,
        "read": false,
        "write": false
    },
    {
        "eventKey": "staff",
        "label": "Staffs",
        "path": "/:lng/settings/staff",
        "crud": false,
        "read": false,
        "write": false,
        "subeventKey": [
            {
                "eventKey": "personal",
                "label": "Personal",
                "crud": false,
                "read": false,
                "write": false
            },
            {
                "eventKey": "professional",
                "label": "Professional",
                "crud": false,
                "read": false,
                "write": false
            }
        ]
    },
    {
        "eventKey": "quotation",
        "label": "Quotations",
        "path": "/:lng/home/quotation",
        "crud": false,
        "read": false,
        "write": false
    },
    {
        "eventKey": "credit_note",
        "label": "Credit Notes",
        "path": "/:lng/home/credit_note",
        "crud": false,
        "read": false,
        "write": false
    },
    // {
    //     "eventKey": "reports",
    //     "label": "Report",
    //     "path": "/:lng/reports",
    //     "crud": false,
    //     "read": false,
    //     "write": false
    // },
    {
        "eventKey": "reports",
        "label": "Reports",
        "crud": false,
        "read": false,
        "write": false,
        "subeventKey": [
            // {
            //     "eventKey": "occupancy_forecast",
            //     "label": "Occupancy Forecast",
            //     "crud": false,
            //     "read": false,
            //     "write": false
            // },
            {
                "eventKey": "occupancy_summary",
                "label": "Occupancy Summary",
                "crud": false,
                "read": false,
                "write": false
            },
            // {
            //     "eventKey": "occupancy_analysis",
            //     "label": "Occupancy Analysis",
            //     "crud": false,
            //     "read": false,
            //     "write": false
            // },
            {
                "eventKey": "in_house_report",
                "label": "In-House Report",
                "crud": false,
                "read": false,
                "write": false
            },
            // {
            //     "eventKey": "checkout_pending",
            //     "label": "Checkout Pending",
            //     "crud": false,
            //     "read": false,
            //     "write": false
            // },
            {
                "eventKey": "expected_arrivals",
                "label": "Expected Arrivals",
                "crud": false,
                "read": false,
                "write": false
            },
            {
                "eventKey": "reservation_status",
                "label": "Reservation Status",
                "crud": false,
                "read": false,
                "write": false
            },
            {
                "eventKey": "customer_analytics",
                "label": "Customer Analytics",
                "crud": false,
                "read": false,
                "write": false
            },
            {
                "eventKey": "check_in_report",
                "label": "Check-In Report",
                "crud": false,
                "read": false,
                "write": false
            },
            {
                "eventKey": "checkout_report",
                "label": "Checkout Report",
                "crud": false,
                "read": false,
                "write": false
            },
            {
                "eventKey": "guest_ledger",
                "label": "Guest Ledger",
                "crud": false,
                "read": false,
                "write": false
            },
            {
                "eventKey": "no_show_report",
                "label": "No Show Report",
                "crud": false,
                "read": false,
                "write": false
            },
            // {
            //     "eventKey": "room_shift",
            //     "label": "Room Shift",
            //     "crud": false,
            //     "read": false,
            //     "write": false
            // },
            {
                "eventKey": "early_checkout",
                "label": "Early Checkout",
                "crud": false,
                "read": false,
                "write": false
            },
            {
                "eventKey": "cancellation_report",
                "label": "Cancellation Report",
                "crud": false,
                "read": false,
                "write": false
            },
            {
                "eventKey": "payment_transactions",
                "label": "Payment Transactions",
                "crud": false,
                "read": false,
                "write": false
            },
            {
                "eventKey": "daily_flash_revenue",
                "label": "Daily/Flash Revenue",
                "crud": false,
                "read": false,
                "write": false
            },
            {
                "eventKey": "sales_summary",
                "label": "Sales Summary",
                "crud": false,
                "read": false,
                "write": false
            },
            {
                "eventKey": "room_revenue",
                "label": "Room Tariff Report",
                "crud": false,
                "read": false,
                "write": false
            },
            // {
            //     "eventKey": "night_audit",
            //     "label": "Night Audit",
            //     "crud": false,
            //     "read": false,
            //     "write": false
            // },
            // {
            //     "eventKey": "segment_analysis",
            //     "label": "Segment Analysis",
            //     "crud": false,
            //     "read": false,
            //     "write": false
            // },
            // {
            //     "eventKey": "complimentary",
            //     "label": "Complimentary",
            //     "crud": false,
            //     "read": false,
            //     "write": false
            // },
            {
                "eventKey": "extra_charges",
                "label": "Extra Charges",
                "crud": false,
                "read": false,
                "write": false
            },
            // {
            //     "eventKey": "all_modifications",
            //     "label": "All Modifications",
            //     "crud": false,
            //     "read": false,
            //     "write": false
            // },
            {
                "eventKey": "ota_performance",
                "label": "OTA Performance",
                "crud": false,
                "read": false,
                "write": false
            },
            {
                "eventKey": "fb_revenue",
                "label": "F&B Billing Report",
                "crud": false,
                "read": false,
                "write": false
            },
            // {
            //     "eventKey": "geographical_revenue",
            //     "label": "Geographical Revenue",
            //     "crud": false,
            //     "read": false,
            //     "write": false
            // },
            {
                "eventKey": "all_revenue",
                "label": "All Revenue",
                "crud": false,
                "read": false,
                "write": false
            },
            // {
            //     "eventKey": "tax_report",
            //     "label": "Tax Report",
            //     "crud": false,
            //     "read": false,
            //     "write": false
            // },
            {
                "eventKey": "settlement_report",
                "label": "Settlement Report",
                "crud": false,
                "read": false,
                "write": false
            },
            {
                "eventKey": "general_collection",
                "label": "General Collection",
                "crud": false,
                "read": false,
                "write": false
            },
            {
                "eventKey": "vendor_payments",
                "label": "Vendor Payments",
                "crud": false,
                "read": false,
                "write": false
            },
            {
                "eventKey": "user_account_collection",
                "label": "Staff Account Collection",
                "crud": false,
                "read": false,
                "write": false
            },
            // {
            //     "eventKey": "shift_wise_collection",
            //     "label": "Shift Wise Collection",
            //     "crud": false,
            //     "read": false,
            //     "write": false
            // },
            {
                "eventKey": "gstr1_report",
                "label": "GSTR-1 Report",
                "crud": false,
                "read": false,
                "write": false
            },
            {
                "eventKey": "gstr3b_report",
                "label": "GSTR-3B Report",
                "crud": false,
                "read": false,
                "write": false
            },
            {
                "eventKey": "hsn_sac_summary",
                "label": "HSN/SAC Summary",
                "crud": false,
                "read": false,
                "write": false
            },
            {
                "eventKey": "itc_report",
                "label": "ITC Report",
                "crud": false,
                "read": false,
                "write": false
            },
            {
                "eventKey": "purchase_register",
                "label": "Purchase Register",
                "crud": false,
                "read": false,
                "write": false
            },
            {
                "eventKey": "credit_notes",
                "label": "Credit Notes",
                "crud": false,
                "read": false,
                "write": false
            },
            {
                "eventKey": "tax_rate_wise_gst",
                "label": "Tax Rate Wise GST",
                "crud": false,
                "read": false,
                "write": false
            },
            {
                "eventKey": "cancellation_gst",
                "label": "Cancellation GST",
                "crud": false,
                "read": false,
                "write": false
            },
            {
                "eventKey": "folio_transfer_report",
                "label": "Folio Transfer Report",
                "crud": false,
                "read": false,
                "write": false
            },
            // {
            //     "eventKey": "folio_balance_report",
            //     "label": "Folio Balance Report",
            //     "crud": false,
            //     "read": false,
            //     "write": false
            // },
            // {
            //     "eventKey": "folio_adjustment_report",
            //     "label": "Folio Adjustment Report",
            //     "crud": false,
            //     "read": false,
            //     "write": false
            // },
            {
                "eventKey": "general_report",
                "label": "General Report",
                "crud": false,
                "read": false,
                "write": false
            },
            // {
            //     "eventKey": "policy_report",
            //     "label": "Policy Report",
            //     "crud": false,
            //     "read": false,
            //     "write": false
            // },
            // {
            //     "eventKey": "feedback_report",
            //     "label": "Feedback Report",
            //     "crud": false,
            //     "read": false,
            //     "write": false
            // },

        ]
    },
    {
        "eventKey": "account_payment",
        "label": "Account & Payments",
        "path": "/:lng/home/account_payment",
        "crud": false,
        "read": false,
        "write": false,
        "subeventKey": [
            {
                "eventKey": "beneficiaries",
                "label": "Vendors",
                "path": "/:lng/home/account_payment/beneficiaries",
                "crud": false,
                "read": false,
                "write": false
            },
            {
                "eventKey": "pending_settlements",
                "label": "Pending Settlements",
                "path": "/:lng/home/account_payment/pending_settlements",
                "crud": false,
                "read": false,
                "write": false
            },
            {
                "eventKey": "transactions",
                "label": "Transactions",
                "path": "/:lng/home/account_payment/transactions",
                "crud": false,
                "read": false,
                "write": false
            },
            {
                "eventKey": "vendor_report",
                "label": "Vendor Report",
                "path": "/:lng/home/account_payment/vendor_report",
                "crud": false,
                "read": false,
                "write": false
            }
        ]
    },
    {
        "eventKey": "revenue_manager",
        "label": "Revenue Manager",
        "path": "/:lng/revenue_manager",
        "crud": false,
        "read": false,
        "write": false
    },
]